import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomerItem } from './customer-item.model';
import { Page } from '../../models/page-wrapper.model';

export interface CustomerItemSearchParams {
  [key: string]: string | number | undefined | null;
  customerItemNumber?: string;
  customerItemDescription?: string;
  customerNumber?: string;
  tamerItemNumber?: string;
  brandName?: string;
  subBrandName?: string;
  customerId?: number;
  tamerItemId?: number;
  brandId?: number;
  subBrandId?: number;
  page?: number;
  size?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerItemService {

  private apiUrl = `${environment.restApiUrl}customer-items`;

  constructor(private http: HttpClient) { }

  private buildSearchParams(searchParams: CustomerItemSearchParams): HttpParams {
    let params = new HttpParams();
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, String(value));
      }
    });
    return params;
  }

  findAll(searchParams: CustomerItemSearchParams): Observable<Page<CustomerItem>> {
    const params = this.buildSearchParams(searchParams);
    return this.http.get<Page<CustomerItem>>(this.apiUrl, { params });
  }

  findById(id: number): Observable<CustomerItem> {
    return this.http.get<CustomerItem>(`${this.apiUrl}/${id}`);
  }

  create(customerItem: CustomerItem): Observable<CustomerItem> {
    return this.http.post<CustomerItem>(this.apiUrl, customerItem);
  }

  update(id: number, customerItem: CustomerItem): Observable<CustomerItem> {
    return this.http.put<CustomerItem>(`${this.apiUrl}/${id}`, customerItem);
  }

  deleteById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
